import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '..';
import { NEWSLETTER_URL_ORGS, NEWSLETTER_URL_PRIVATE } from '../../config/constants';

import './style.scss';

const NewsletterForm = () => {
  const { t } = useTranslation();

  return (
    <div className="FooterMenu__newsletter">
      {/* TODO: implement as webform */}
      <h4>{t('newsletter.title')}</h4>
      <p>{t('newsletter.body')}</p>
      <CoreLink className="Button Button--primary Button--icon icon-after icon-arrow-right icon-before moving-arrow icon-variant-4" to={NEWSLETTER_URL_ORGS}>{t('newsletter.button-text')}</CoreLink>
      <CoreLink className="Button__link icon-after icon-before icon-arrow-right icon-variant-2 moving-arrow" to={NEWSLETTER_URL_PRIVATE}>{t('newsletter.private-link-text')}</CoreLink>
    </div>
  );
};

export default NewsletterForm;
